import React from 'react';
import ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import './index.css';
import App from './App';
import './i18n';
import reportWebVitals from './reportWebVitals';
import { CALPAL_THEME } from './common/colors';
import { SubscribeModalProvider } from './SubscribeModalContext';

const theme = createTheme(CALPAL_THEME);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    //  uncomment this StrictMode wrapper to help local debugging in search of possible side effects, but it will intentionally re-render top level component twice
    // <React.StrictMode>
    <>
        <Analytics />
        <SpeedInsights />
        <ThemeProvider theme={theme}>
            <SubscribeModalProvider>
                <CssBaseline />
                <App />
            </SubscribeModalProvider>
        </ThemeProvider>
    </>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
